"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopiaPasswordInput = exports.TopiaEmailInput = exports.TopiaCurrencyInput = exports.TopiaTextInput = exports.TopiaBaseInput = exports.BASE_INPUT_CLASSES = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var helpers_1 = require("../helpers");
exports.BASE_INPUT_CLASSES = 'block w-full rounded-xl bg-white border-black/20 p-4 my-2 font-light text-topia-black placeholder:text-topia-gray';
function TopiaBaseInput(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(props.className), children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: props.id, className: "block text-sm font-medium ".concat(props.labelColor ? props.labelColor : 'text-white'), children: props.label }), (0, jsx_runtime_1.jsx)("div", { className: "mt-1", children: (0, jsx_runtime_1.jsx)("input", __assign({ type: props.inputProps.type, id: props.id, 
                    // placeholder={props.label}
                    className: exports.BASE_INPUT_CLASSES }, props.inputProps)) })] }));
}
exports.TopiaBaseInput = TopiaBaseInput;
var TopiaTextInput = function (props) { return ((0, jsx_runtime_1.jsx)(TopiaBaseInput, __assign({}, props, { inputProps: __assign(__assign({}, props.inputProps), { type: 'text' }) }))); };
exports.TopiaTextInput = TopiaTextInput;
var TopiaCurrencyInput = function (props) { return ((0, jsx_runtime_1.jsxs)("div", { className: "relative", children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute right-6 bottom-1/4 text-md text-topia-gray", children: (0, helpers_1.getCurrencySymbol)() }), (0, jsx_runtime_1.jsx)(TopiaBaseInput, __assign({ labelType: "above" }, props, { inputProps: __assign(__assign({}, props.inputProps), { type: 'number', placeholder: undefined, step: 0.01 }) }))] })); };
exports.TopiaCurrencyInput = TopiaCurrencyInput;
var TopiaEmailInput = function (props) { return ((0, jsx_runtime_1.jsx)(TopiaBaseInput, __assign({}, props, { inputProps: __assign(__assign({}, props.inputProps), { type: 'email' }) }))); };
exports.TopiaEmailInput = TopiaEmailInput;
var TopiaPasswordInput = function (props) { return ((0, jsx_runtime_1.jsx)(TopiaBaseInput, __assign({}, props, { inputProps: __assign(__assign({}, props.inputProps), { type: 'password' }) }))); };
exports.TopiaPasswordInput = TopiaPasswordInput;
